export default {_name:'acl.grid.form.section',module:'Card/Form',view:'Element/Acl/Section',options:{component:'section',events:{acl:'acl'}}}